import React, { Component } from "react";
import { Button, message, Spin, Tag, Popover } from "antd";
import CustomSelect from "../../../../../components/CustomFields/CustomSelect";
import CustomDatePicker from "../../../../../components/CustomFields/CustomDatePicker";
import CustomTextArea from "../../../../../components/CustomFields/CustomTextArea";
import CustomInput from "../../../../../components/CustomFields/CustomInput";
import CustomInputNumber from "../../../../../components/CustomFields/CustomInputNumber";
import moment from "moment";
import axiosJSON from "../../../../../util/SetHeaderAPI";
import axios from "axios";
// import { InfoCircleOutlined } from "@ant-design/icons";
import CustomUpload from "../../../../../components/CustomFields/CustomUpload";
import { MdOpenInNew } from "react-icons/md";
import { FiHeadphones } from "react-icons/fi";
import { GrDocumentText } from "react-icons/gr";
import { BsArrowRepeat, BsInfoCircle } from "react-icons/bs";
import { BASE_URL } from "../../../../../util/Api";

class InternalForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      resume: "",
      fileList: {},
      inputFields: [],
      formName: "",
      loading: false,
      disabled: true,
      otpDialog: false,
      otpValue: "",
      checkFlag: {},
      checkFileFlag: {},
      formSuccess: false,
      link: "",
      employeeId: "",
      showDataFields: false,
      fields: {},
      fileName: "",
      validationRequired: true,
    };
    this.Mounted = false;
  }

  componentWillUnmount() {
    this.Mounted = false;
  }

  componentDidMount() {
    this.Mounted = true;
    this.getFormData();
  }

  getFormData = () => {
    let link = "";
    this.setState({
      loading: true,
    });
    if (!this.props.history.location.search.includes("&")) {
      link = this.props.history.location.search.split("=")[1];
    } else {
      link = this.props.history.location.search.split("&")[0].split("=")[1];
      this.props.history.location.search.split("&") &&
        this.props.history.location.search.split("&").map((key, index) => {
          let queryParams = key.split("=");
          this.setState({
            spinning: false,
            loading: false,
            [queryParams[0]]: queryParams[1],
          });
          return null;
        });
    }
    axiosJSON
      .get("/api/form/?link=" + link)
      .then(({ data, status }) => {
        this.setState({
          link: data.data.link,
          loading: false,
          validationRequired:
            data.data.validation_required !== null
              ? data.data.validation_required
              : true,
          spinning: false,
          inputFields: data.data.form_attributes,
          outputFields: data.data.form_attributes.map((item) => {
            return {
              id: item.id,
              name: item.name,
              value: null,
            };
          }),
          formName: data.data.name,
        });
        if (data.data.validation_required === false) {
          this.setState({
            otpDialog: false,
            validationRequired: false,
            disableEmail: false,
            showDataFields: true,
            removeVerify: false,
            loading: false,
            disabled: false,
          });
        }
      })
      .catch((err) => {
        message.error(err.message);
        this.setState({
          spinning: false,
          loading: false,
        });
      });
  };
  onChange = (type, name, event) => {
    this.setState({
      checkFlag: {},
      checkFileFlag: {},
    });
    switch (type) {
      case "text":
        this.onInputChange(event.target.value, name);
        break;
      case "longtext":
        this.onInputChange(event.target.value, name);
        break;
      case "number":
        this.onInputChange(event, name);
        break;
      case "select":
        this.onInputChange(event, name);
        break;
      case "multiselect":
        this.onInputChange(event, name);
        break;

      case "datepicker":
        this.onDatePickerChange(name, event);
        break;
      case "file":
        this.onUploadChange(name, event);
        break;
      default:
        break;
    }
  };
  onInputChange = (e, name) => {
    let fields = { ...this.state.fields };
    fields[name] = e;
    this.setState({
      fields: fields,
    });
    if (name === "employee_id") {
      this.setState({
        employeeId: e,
        fields: fields,
      });
    }
  };
  onDatePickerChange = (name, e) => {
    let fields = { ...this.state.fields };
    fields[name] = moment(e, "DD-MM-YYYY");
    this.setState({
      fields: fields,
    });
  };
  setResumeData = (data) => {
    let fields = { ...this.state.fields };
    fields["name"] = data.candidate.name;
    fields["candidate_email"] = data.candidate.email;
    fields["phone_numbers"] = data.candidate.phone;
    fields["resume"] = data.resume;
    this.setState({
      fields: fields,
      email: data.candidate.email,
      resume: data.resume,
      name: data.candidate.name,
      spinning: false,
    });
  };
  onUploadChange = (name, e) => {
    let fileList = { ...this.state.fileList };
    fileList[name] = [e.file.originFileObj];
    this.setState({
      fileList: fileList,
    });
    if (name === "resume") this.handleChange(e);
  };
  onUploadRemove = (name) => {
    let fileList = { ...this.state.fileList };
    delete fileList[name];
    this.setState({
      email: "",
      resume: "",
      name: "",
      spinning: false,
      fileList: fileList,
    });
  };
  handleChange = async (info) => {
    const formData = new FormData();
    this.setState({
      showDataFields: true,
      spinning: true,
    });
    formData.append("file", info.file.originFileObj);
    await axios
      .post(`${BASE_URL}/api/form/resume_parse/`, formData)
      .then(({ data, status }) => {
        if (status === 200) {
          let candidate = {
            name: data.data.name,
            email: data.data.email,
            phone: data.data.mobile_number,
            spinning: false,
          };
          let d = {
            candidate: candidate,
            resume: data.resume,
          };
          this.setState({
            spinning: false,
          });
          this.setResumeData(d);
        } else {
          message.error("Parsing error");
          this.setState({
            spinning: false,
          });
        }
      })
      .catch(function (error) {
          this.setState({
            spinning: false,
          });
          message.error(error.message);
      });
  };

  onSubmit = () => {
    this.setState({
      spinning: true,
    });
    let obj = {};
    let fileObj = {};
    let n = "";
    let fileName = "";
    if (this.state.inputFields.length !== 0) {
      this.state.inputFields.map((field) => {
        n = field.name;
        if (
          field.required &&
          !this.state.fields[field.name] &&
          field.type !== "file"
        ) {
          obj[n] = true;
        } else {
          obj[n] = false;
        }
        return obj;
      });
    }
    if (this.state.inputFields.length !== 0) {
      this.state.inputFields.map((field) => {
        fileName = field.name;
        if (
          field.required &&
          field.type === "file" &&
          !this.state.fileList[field.name]
        ) {
          fileObj[fileName] = true;
        } else {
          fileObj[fileName] = false;
        }
        return fileObj;
      });
    }
    let flag =
      Object.values(obj).every((k) => k === false) &&
      Object.values(fileObj).every((k) => k === false);
    if (flag) {
      let value = {};
      let values_arr = [];
      this.state.inputFields.map((field) => {
        if (field.type !== "file") {
          value = {
            attribute_id: field.id,
            value: this.state.fields[field.name],
            name: field.name,
          };
          values_arr.push(value);
        }
        return null;
      });
      let formData = new FormData();
      formData.append("employee_id", this.state.employeeId);
      formData.append("link", this.state.link);
      for (let key in this.state.fileList) {
        formData.append(key, this.state.fileList[key][0]);
      }
      formData.append("values", JSON.stringify(values_arr));
      axiosJSON
        .post("/api/form/", formData)
        .then(({ data, status }) => {
          message.success("Form Submitted");
          this.setState({
            formSuccess: true,
            spinning: false,
          });
        })
        .catch((err) => {
          this.setState({
            disabled: false,
            spinning: false,
          });
          message.error(err.message);
        });
    } else {
      this.setState({
        checkFlag: obj,
        spinning: false,
        checkFileFlag: fileObj,
      });
      message.error("Please fill the required fields");
    }
  };

  verifyEmployeeId = () => {
    if (!this.state.employeeId) {
      message.error("Please enter a valid Employee Id");
      return;
    }
    this.setState({
      spinning: true,
    });
    const body = {
      employee_id: this.state.employeeId,
      link: this.props.history.location.search.split("=")[1],
    };
    axiosJSON
      .post("/api/form/request_otp/", body)
      .then(({ data, status }) => {
        message.warn(data.message);
        this.setState({
          otpDialog: false,
          disabled: false,
          otpValue: "1234",
          showDataFields: true,
          spinning: false,
        });
      })
      .catch((err) => {
        this.setState({
          spinning: false,
        });
        message.error(err.message);
      });
  };

  getAccept = (name) => {
    if (name === "resume") return ".pdf,.docx";
    else return ".pdf,.docx,.jpeg,.png,.jpg,.heic";
  };

  render() {
    return (
      <div className="gx-main-content main_application_page">
        {this.state.loading ? (
          <Spin spinning={this.state.spinning} tip="Please wait..." />
        ) : (
          <div className="main">
            <div className="header header-assert">
              <div className="logo-assert">
                <img
                  style={{ maxHeight: "36px" }}
                  alt="consultadd"
                  src="https://consultadd.com/wp-content/uploads/2022/11/consultadd-logo.svg"
                />
              </div>
              <div className="assert_nav">
                <div className="pr-4 center-assert">
                  <a href="https://consultadd.com/" className="home-assert">
                    Go to website home page <MdOpenInNew />
                  </a>
                </div>
                <div>
                  <a
                    className="contact_us-assert"
                    href="https://consultadd.com/contact/"
                  >
                    <FiHeadphones /> Contact Us
                  </a>
                </div>
              </div>
            </div>

            <Spin spinning={this.state.spinning} tip="Please wait...">
              {!this.state.formSuccess ? (
                <div className="main-app-form">
                  <div className="headline">
                    <div className="col-12">
                      <div className="heading-application mb-1">
                        <div style={{ marginBottom: "40px" }}>
                          {this.state.formName
                            ? this.state.formName
                            : "Internal Form"}
                        </div>
                      </div>
                      <div className="sub-heading-application">
                        {/* Please enter your email for verification. */}
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    {this.state.inputFields.length !== 0 &&
                      this.state.inputFields.map((field, i) => (
                        <div key={i}>
                          <div key={i}>
                            <div className="application-form">
                              {field.name === "employee_id" ? (
                                <div className="textbox-email">
                                  <div className="form-test-section">
                                    <div className="verify-section col-8">
                                      <span className="gx-text-black gx-fs-xl input-label">
                                        {field.required && (
                                          <span className="gx-text-grey gx-fs-md right-required">
                                            *
                                          </span>
                                        )}
                                        {field.display_name}
                                        {field.description ? (
                                          <Popover
                                            className="gx-text-grey gx-fs-md right-required"
                                            content={field.description}
                                          >
                                            <BsInfoCircle
                                              style={{
                                                cursor: "pointer",
                                                marginLeft: "5px",
                                                color: "black",
                                                marginTop: "-3px",
                                              }}
                                            />
                                          </Popover>
                                        ) : null}
                                      </span>
                                      <CustomInput
                                        onChange={(e) =>
                                          this.onChange(
                                            field.type,
                                            field.name,
                                            e.target.value
                                          )
                                        }
                                        value={this.state.fields[field.name]}
                                        key={field.name}
                                        name={field.name}
                                        disabled={this.state.otpValue !== ""}
                                        placeholder={field.display_name}
                                      />
                                      {!this.state.otpDialog &&
                                      this.state.otpValue === "" &&
                                      this.state.validationRequired &&
                                      field.name === "employee_id" ? (
                                        <Button
                                          className="verify-external mt-2"
                                          disabled={this.state.fields === ""}
                                          onClick={this.verifyEmployeeId}
                                        >
                                          Verify
                                        </Button>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              ) : !this.state.disabled &&
                                this.state.showDataFields &&
                                field.type === "text" ? (
                                <div className="textbox-email">
                                  <div className="form-test-section">
                                    <div className="verify-section col-8">
                                      <span className="gx-text-black gx-fs-xl input-label">
                                        {field.required && (
                                          <span className="gx-text-grey gx-fs-md right-required">
                                            *
                                          </span>
                                        )}
                                        {field.display_name}
                                        {field.description ? (
                                          <Popover
                                            className="gx-text-grey gx-fs-md right-required"
                                            content={field.description}
                                          >
                                            <BsInfoCircle
                                              style={{
                                                cursor: "pointer",
                                                marginLeft: "5px",
                                                color: "black",
                                                marginTop: "-3px",
                                              }}
                                            />
                                          </Popover>
                                        ) : null}
                                      </span>

                                      <CustomInput
                                        onChange={(e) =>
                                          this.onChange(
                                            field.type,
                                            field.name,
                                            e
                                          )
                                        }
                                        value={
                                          this.state.fields[`${field.name}`]
                                        }
                                        key={field.name}
                                        name={field.name}
                                        placeholder={field.display_name}
                                      />
                                      {field.required &&
                                      this.state.checkFlag[field.name] ? (
                                        <span className="gx-text-red gx-fs-md">
                                          {field.display_name} cannot be empty
                                        </span>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              ) : !this.state.disabled &&
                                this.state.showDataFields &&
                                field.name !== "employee_id" &&
                                field.type === "number" ? (
                                <div className="textbox-email">
                                  <div className="form-test-section ">
                                    <div className="verify-section col-8">
                                      <span className="gx-text-black gx-fs-xl input-label">
                                        {field.required && (
                                          <span className="gx-text-grey gx-fs-md right-required">
                                            *
                                          </span>
                                        )}
                                        {field.display_name}
                                        {field.description ? (
                                          <Popover
                                            className="gx-text-grey gx-fs-md right-required"
                                            content={field.description}
                                          >
                                            <BsInfoCircle
                                              style={{
                                                cursor: "pointer",
                                                marginLeft: "5px",
                                                color: "black",
                                                marginTop: "-3px",
                                              }}
                                            />
                                          </Popover>
                                        ) : null}
                                      </span>

                                      <CustomInputNumber
                                        onChange={(e) =>
                                          this.onChange(
                                            field.type,
                                            field.name,
                                            e
                                          )
                                        }
                                        value={
                                          this.state.fields[`${field.name}`]
                                        }
                                        key={field.name}
                                        name={field.name}
                                        placeholder={field.display_name}
                                      />
                                      {field.required &&
                                      this.state.checkFlag[field.name] ? (
                                        <span className="gx-text-red gx-fs-md">
                                          {field.display_name} cannot be empty
                                        </span>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              ) : !this.state.disabled &&
                                this.state.showDataFields &&
                                field.type === "longtext" ? (
                                <div className="textbox-email">
                                  <div className="form-test-section ">
                                    <div className="verify-section col-8">
                                      <span className="gx-text-black gx-fs-xl input-label">
                                        {field.required && (
                                          <span className="gx-text-grey gx-fs-md right-required">
                                            *
                                          </span>
                                        )}
                                        {field.display_name}
                                        {field.description ? (
                                          <Popover
                                            className="gx-text-grey gx-fs-md right-required"
                                            content={field.description}
                                          >
                                            <BsInfoCircle
                                              style={{
                                                cursor: "pointer",
                                                marginLeft: "5px",
                                                color: "black",
                                                marginTop: "-3px",
                                              }}
                                            />
                                          </Popover>
                                        ) : null}
                                      </span>

                                      <CustomTextArea
                                        onChange={(e) =>
                                          this.onChange(
                                            field.type,
                                            field.name,
                                            e
                                          )
                                        }
                                        value={
                                          this.state.fields[`${field.name}`]
                                        }
                                        key={field.name}
                                        name={field.name}
                                        placeholder={field.display_name}
                                      />
                                      {field.required &&
                                      this.state.checkFlag[field.name] ? (
                                        <span className="gx-text-red gx-fs-md">
                                          {field.display_name} cannot be empty
                                        </span>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              ) : !this.state.disabled &&
                                this.state.showDataFields &&
                                field.type === "select" ? (
                                <div className="textbox-email">
                                  <div className="form-test-section ">
                                    <div className="verify-section col-8">
                                      <span className="gx-text-black gx-fs-xl input-label">
                                        {field.required && (
                                          <span className="gx-text-grey gx-fs-md right-required">
                                            *
                                          </span>
                                        )}
                                        {field.display_name}
                                        {field.description ? (
                                          <Popover
                                            className="gx-text-grey gx-fs-md right-required"
                                            content={field.description}
                                          >
                                            <BsInfoCircle
                                              style={{
                                                cursor: "pointer",
                                                marginLeft: "5px",
                                                color: "black",
                                                marginTop: "-3px",
                                              }}
                                            />
                                          </Popover>
                                        ) : null}
                                      </span>

                                      <CustomSelect
                                        onChange={(e) =>
                                          this.onChange(
                                            field.type,
                                            field.name,
                                            e
                                          )
                                        }
                                        value={
                                          this.state.fields[`${field.name}`]
                                        }
                                        key={field.name}
                                        name={field.name}
                                        options={field.option}
                                        placeholder={field.display_name}
                                      />
                                      {field.required &&
                                      this.state.checkFlag[field.name] ? (
                                        <span className="gx-text-red gx-fs-md">
                                          {field.display_name} cannot be empty
                                        </span>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              ) : !this.state.disabled &&
                                this.state.showDataFields &&
                                field.type === "multiselect" ? (
                                <div className="textbox-email">
                                  <div className="form-test-section ">
                                    <div className="verify-section col-8">
                                      <span className="gx-text-black gx-fs-xl input-label">
                                        {field.required && (
                                          <span className="gx-text-grey gx-fs-md right-required">
                                            *
                                          </span>
                                        )}
                                        {field.display_name}
                                        {field.description ? (
                                          <Popover
                                            className="gx-text-grey gx-fs-md right-required"
                                            content={field.description}
                                          >
                                            <BsInfoCircle
                                              style={{
                                                cursor: "pointer",
                                                marginLeft: "5px",
                                                color: "black",
                                                marginTop: "-3px",
                                              }}
                                            />
                                          </Popover>
                                        ) : null}
                                      </span>

                                      <CustomSelect
                                        onChange={(e) =>
                                          this.onChange(
                                            field.type,
                                            field.name,
                                            e
                                          )
                                        }
                                        value={
                                          this.state.fields[`${field.name}`]
                                        }
                                        key={field.name}
                                        name={field.name}
                                        multiple={true}
                                        options={field.option}
                                        placeholder={field.display_name}
                                      />
                                      {field.required &&
                                      this.state.checkFlag[field.name] ? (
                                        <span className="gx-text-red gx-fs-md">
                                          {field.display_name} cannot be empty
                                        </span>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              ) : !this.state.disabled &&
                                this.state.showDataFields &&
                                field.type === "datepicker" ? (
                                <div className="textbox-email">
                                  <div className="form-test-section ">
                                    <div className="verify-section col-8">
                                      <span className="gx-text-black gx-fs-xl input-label">
                                        {field.required && (
                                          <span className="gx-text-grey gx-fs-md right-required">
                                            *
                                          </span>
                                        )}
                                        {field.display_name}
                                        {field.description ? (
                                          <Popover
                                            className="gx-text-grey gx-fs-md right-required"
                                            content={field.description}
                                          >
                                            <BsInfoCircle
                                              style={{
                                                cursor: "pointer",
                                                marginLeft: "5px",
                                                color: "black",
                                              }}
                                            />
                                          </Popover>
                                        ) : null}
                                      </span>
                                      <CustomDatePicker
                                        value={
                                          this.state.fields[`${field.name}`]
                                        }
                                        onChange={(e) =>
                                          this.onChange(
                                            field.type,
                                            field.name,
                                            e
                                          )
                                        }
                                        key={field.name}
                                        name={field.name}
                                      />
                                      {field.required &&
                                      this.state.checkFlag[field.name] ? (
                                        <span className="gx-text-red gx-fs-md">
                                          {field.display_name} cannot be empty
                                        </span>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              ) : this.state.showDataFields &&
                                field.type === "file" &&
                                !this.state.fileList[field.name] ? (
                                <div className="textbox-email">
                                  <div className="form-test-section">
                                    <div className="verify-section col-8">
                                      <span className="gx-text-black gx-fs-xl input-label">
                                        {field.required && (
                                          <span className="gx-text-grey gx-fs-md right-required">
                                            *
                                          </span>
                                        )}
                                        {field.display_name}
                                        {field.description ? (
                                          <Popover
                                            className="gx-text-grey gx-fs-md right-required"
                                            content={field.description}
                                          >
                                            <BsInfoCircle
                                              style={{
                                                cursor: "pointer",
                                                marginLeft: "5px",
                                                color: "black",
                                              }}
                                            />
                                          </Popover>
                                        ) : null}
                                      </span>
                                      <CustomUpload
                                        fileList={this.state.fileList}
                                        onChange={(e) =>
                                          this.onChange(
                                            field.type,
                                            field.name,
                                            e
                                          )
                                        }
                                        dragger={true}
                                        onRemove={() => this.onFileRemove}
                                        key={field.name}
                                        name={field.name}
                                        accept={this.getAccept(field.name)}
                                      />
                                      {field.required &&
                                      this.state.checkFileFlag[field.name] ? (
                                        <span className="gx-text-red gx-fs-md">
                                          {field.display_name} cannot be empty
                                        </span>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              ) : this.state.showDataFields &&
                                field.type === "file" &&
                                this.state.fileList[field.name] ? (
                                <div className="textbox-email">
                                  <div className="form-test-section ">
                                    <div className="verify-section col-8">
                                      <div className="gx-text-black gx-fs-xl input-label">
                                        {field.required && (
                                          <span className="gx-text-grey gx-fs-md right-required">
                                            *
                                          </span>
                                        )}
                                        {field.display_name}
                                        {field.description ? (
                                          <Popover
                                            className="gx-text-grey gx-fs-md right-required"
                                            content={field.description}
                                          >
                                            <BsInfoCircle
                                              style={{
                                                cursor: "pointer",
                                                marginLeft: "5px",
                                                color: "black",
                                              }}
                                            />
                                          </Popover>
                                        ) : null}
                                      </div>
                                      <div className="upload_input">
                                        <div className="col-9 p-0">
                                          <Tag>
                                            <div className="gx-text-black gx-fs-xl input-label tag-flex-container">
                                              <div className="">
                                                <GrDocumentText className="documentIcon" />
                                                {
                                                  this.state.fileList[
                                                    field.name
                                                  ][0].name
                                                }
                                              </div>
                                            </div>
                                          </Tag>
                                        </div>
                                        <div
                                          className="col-3 reupload"
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            this.onUploadRemove(field.name)
                                          }
                                        >
                                          <BsArrowRepeat />
                                          Reupload
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                  {!this.state.disabled && this.state.showDataFields && (
                    <div className="textbox-email flex-center mt-3">
                      <div className="verify-section col-8">
                        <Button
                          className="verify-external"
                          onClick={this.onSubmit}
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="main" style={{ marginTop: "50px" }}>
                  <div className="thank-you-form">
                    <h1 style={{ color: "#000" }}>
                      <BsInfoCircle
                        style={{
                          color: "#0087f3",
                          fontSize: "22px",
                          marginRight: "10px",
                        }}
                      />
                      Your response has been recorded.
                    </h1>
                    <h3>Thankyou for filling out your information.</h3>
                  </div>
                </div>
              )}
            </Spin>
            <br clear="all" />
          </div>
        )}
      </div>
    );
  }
}

export default InternalForm;
